import { Trans } from 'react-i18next'

import { TranslationComponentProps } from './types'

export function TranslationComponent({
  i18nKey,
  components = {},
  ...props
}: TranslationComponentProps) {
  return <Trans i18nKey={String(i18nKey)} components={components} {...props} />
}
